import { render, staticRenderFns } from "./MatchSignupTeamConfigEdit.vue?vue&type=template&id=cbafd90e&"
import script from "./MatchSignupTeamConfigEdit.vue?vue&type=script&lang=js&"
export * from "./MatchSignupTeamConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports